import { useI18n } from "../../i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-charcoal text-ivory" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-20 py-20 md:py-28 max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-y-12 gap-x-8">
          <div className="col-span-12 md:col-span-6">
            <h3 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-tight whitespace-pre-line">
              {t.footer.tagline}
            </h3>
          </div>
          <div className="col-span-6 md:col-span-3 md:col-start-8">
            <span className="text-[0.65rem] tracking-luxe uppercase text-ivory/50">
              {t.footer.contact}
            </span>
            <ul className="mt-5 space-y-2 text-sm text-ivory/90">
              <li><a href="mailto:sardegnahomecollection@gmail.com" className="link-elegant break-all" data-testid="footer-email">sardegnahomecollection@gmail.com</a></li>
              <li><a href="tel:+393665397779" className="link-elegant" data-testid="footer-phone">+39 366 539 7779</a></li>
              <li className="text-ivory/70">La Caletta · Siniscola (NU)</li>
              <li className="text-ivory/70">Sardegna · Italia</li>
              <li className="text-ivory/60 pt-3 tracking-wide" data-testid="footer-cin">CIN: IT091085C2000U4132</li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <span className="text-[0.65rem] tracking-luxe uppercase text-ivory/50">
              {t.footer.follow}
            </span>
            <ul className="mt-5 space-y-2 text-sm">
              <li>
                <a
                  href="https://instagram.com/lacalettaallalba"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-elegant"
                  data-testid="footer-instagram"
                >
                  Instagram
                </a>
              </li>
              <li><a href="#" className="link-elegant" data-testid="footer-airbnb">Airbnb</a></li>
              <li><a href="#" className="link-elegant" data-testid="footer-booking">Booking</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-ivory/50">
          <span>© {new Date().getFullYear()} La Caletta all'Alba. {t.footer.rights}</span>
          <span className="tracking-luxe uppercase">Sardegna · Mediterraneo</span>
        </div>
      </div>
    </footer>
  );
}
